import {
  Box,
  Flex,
  HStack,
  Text,
  UseToastOptions,
  VStack,
} from '@chakra-ui/react'

import { Icon } from '../Icons/Icon'
import { IconTypes } from '../Icons/icon-registry'
import './Toast.css'

export type ToastProps = {
  children?: React.ReactNode
  icon?: IconTypes
  onClose?: () => void
  render?(props: ToastProps): React.ReactNode
  variant?: 'success' | 'error'
} & Omit<UseToastOptions, 'icon' | 'render' | 'status'>

export const Toast = ({
  children,
  description,
  id = 'toast',
  title,
  onClose,
  icon,
  variant,
}: ToastProps) => (
  <HStack
    key={id}
    borderRadius="8px"
    alignItems="stretch"
    boxShadow="0px 1px 13px 0px rgba(0, 0, 0, 0.10), 0px 1px 10px 0px rgba(0, 0, 0, 0.10)"
    gap="0"
    bgColor="presets.neutral.0"
    color="presets.turquoise.100"
    overflow="hidden"
  >
    <Flex
      px="8px"
      bg={variant === 'error' ? 'presets.pink.70' : 'presets.turquoise.30'}
      alignItems="center"
      justifyContent="center"
    >
      <Icon
        icon={
          icon || (variant === 'error' ? 'OutlineCloseIcon' : 'CompleteIcon')
        }
        color="presets.neutral.0"
        boxSize="18px"
      />
    </Flex>
    <VStack w="100%" alignItems="flex-start" p="12px 12px 14px 16px">
      <HStack
        h="100%"
        w="100%"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <VStack alignItems="flex-start">
          {title && (
            <Text fontWeight="600" fontSize="12px">
              {title}
            </Text>
          )}
          {description && <Text fontSize="12px">{description}</Text>}
          {children && <Box fontSize="12px">{children}</Box>}
        </VStack>
        <Icon cursor="pointer" icon="XIcon" onClick={onClose} boxSize="14px" />
      </HStack>
    </VStack>
  </HStack>
)
